export const ACTIONS = {
  ENQUEUE_SNACKBAR: "ENQUEUE_SNACKBAR",
  CLOSE_SNACKBAR: "CLOSE_SNACKBAR",
  REMOVE_SNACKBAR: "REMOVE_SNACKBAR",
};
